<template>
  <div class="ProgramActivity-app-list-page w-100">
    <Wrapper>
      
              <b-row>
                  <b-col cols="3">
                      <basic-input 
                       label= "Code"
                       placeholder="Nhập Code"
                       name="code"
                       :value.sync="filter.code">
                       </basic-input>
                  </b-col>
                  <b-col cols="3">
                      <basic-input 
                       label= "Name"
                       placeholder="Nhập Name"
                       name="name"
                       :value.sync="filter.name">
                       </basic-input>
                  </b-col>
                  <b-col cols="3">
                      
                  </b-col>
              </b-row>
              <b-row>
                  <b-col cols="3">
                      
                  </b-col>
                  <b-col cols="3">
                      
                  </b-col>
                  <b-col cols="3">
                      
                  </b-col>
              </b-row>
              <b-row>
                  <b-col cols="3">
                      <basic-input 
                       label= "Subject"
                       placeholder="Nhập Subject"
                       name="subject"
                       :value.sync="filter.subject">
                       </basic-input>
                  </b-col>
                  <b-col cols="3">
                      <basic-input 
                       label= "StartDateTime"
                       placeholder="Nhập StartDateTime"
                       name="startDateTime"
                       :value.sync="filter.startDateTime">
                       </basic-input>
                  </b-col>
                  <b-col cols="3">
                      <basic-input 
                       label= "EndDateTime"
                       placeholder="Nhập EndDateTime"
                       name="endDateTime"
                       :value.sync="filter.endDateTime">
                       </basic-input>
                  </b-col>
              </b-row>
              <b-row>
                  <b-col cols="3">
                      <basic-input 
                       label= "ReminderNumbers"
                       placeholder="Nhập ReminderNumbers"
                       name="reminderNumbers"
                       :value.sync="filter.reminderNumbers">
                       </basic-input>
                  </b-col>
                  <b-col cols="3">
                      <basic-input 
                       label= "DetailLink"
                       placeholder="Nhập DetailLink"
                       name="detailLink"
                       :value.sync="filter.detailLink">
                       </basic-input>
                  </b-col>
                  <b-col cols="3">
                      <basic-input 
                       label= "RedirectLink"
                       placeholder="Nhập RedirectLink"
                       name="redirectLink"
                       :value.sync="filter.redirectLink">
                       </basic-input>
                  </b-col>
              </b-row>
              <b-row>
                  <b-col cols="3">
                      <basic-input 
                       label= "VideoLink"
                       placeholder="Nhập VideoLink"
                       name="videoLink"
                       :value.sync="filter.videoLink">
                       </basic-input>
                  </b-col>
              </b-row>
      <b-row>
          <b-col cols="12">
            <b-dropdown
              id="dropdown-right dropdown-form"
              class="dropdown-form-filter"
              no-caret
              right>
              <template #button-content>
                <span class="svg-icon">
                  <inline-svg src="/media/svg/icons/Neolex/Basic/filter.svg" />
                </span>
                Bộ lọc
              </template>
              <h6 class="d-flex align-items-center mb-0 p-4">
                <span class="svg-icon mr-3">
                  <inline-svg src="/media/svg/icons/Neolex/Basic/filter.svg" />
                </span>
                Bộ lọc
              </h6>
              <b-dropdown-divider> </b-dropdown-divider>
              <b-dropdown-form>
                <b-container class="p-0">
                  
        <b-row>
            <b-col>
                <basic-input 
                 label= "Code"
                 placeholder="Nhập Code"
                 name="code"
                 :value.sync="filter.code">
                 </basic-input>
            </b-col>
            <b-col>
                <basic-input 
                 label= "Name"
                 placeholder="Nhập Name"
                 name="name"
                 :value.sync="filter.name">
                 </basic-input>
            </b-col>
            <b-col>
                
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                
            </b-col>
            <b-col>
                
            </b-col>
            <b-col>
                
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <basic-input 
                 label= "Subject"
                 placeholder="Nhập Subject"
                 name="subject"
                 :value.sync="filter.subject">
                 </basic-input>
            </b-col>
            <b-col>
                <basic-input 
                 label= "StartDateTime"
                 placeholder="Nhập StartDateTime"
                 name="startDateTime"
                 :value.sync="filter.startDateTime">
                 </basic-input>
            </b-col>
            <b-col>
                <basic-input 
                 label= "EndDateTime"
                 placeholder="Nhập EndDateTime"
                 name="endDateTime"
                 :value.sync="filter.endDateTime">
                 </basic-input>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <basic-input 
                 label= "ReminderNumbers"
                 placeholder="Nhập ReminderNumbers"
                 name="reminderNumbers"
                 :value.sync="filter.reminderNumbers">
                 </basic-input>
            </b-col>
            <b-col>
                <basic-input 
                 label= "DetailLink"
                 placeholder="Nhập DetailLink"
                 name="detailLink"
                 :value.sync="filter.detailLink">
                 </basic-input>
            </b-col>
            <b-col>
                <basic-input 
                 label= "RedirectLink"
                 placeholder="Nhập RedirectLink"
                 name="redirectLink"
                 :value.sync="filter.redirectLink">
                 </basic-input>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <basic-input 
                 label= "VideoLink"
                 placeholder="Nhập VideoLink"
                 name="videoLink"
                 :value.sync="filter.videoLink">
                 </basic-input>
            </b-col>
        </b-row>
                </b-container>
              </b-dropdown-form>
              <b-dropdown-divider> </b-dropdown-divider>
              <div class="d-flex align-items-center justify-content-lg-end m-0 p-4">
                <b-button
                  class="btn ml-2"
                  href="#"
                  tabindex="0"
                  @click="resetRequest"
                >
                  <span class="svg-icon">
                    <inline-svg
                      src="/media/svg/icons/Neolex/Basic/refresh-cw.svg"
                    />
                  </span>
                  Reset bộ lọc
                </b-button>
                <b-button
                  class="btn ml-2"
                  href="#"
                  tabindex="0"
                  @click="searchRequest"
                >
                  <span class="svg-icon">
                    <inline-svg src="/media/svg/icons/Neolex/Basic/filter.svg" />
                  </span>
                  Lọc dữ liệu
                </b-button>
              </div>
            </b-dropdown>
            <b-button
              v-if="isInsertPermission"
              class="btn btn-success ml-2"
              type="button"
              @click="createItem"
            >
              <span class="svg-icon">
                <inline-svg src="/media/svg/icons/Neolex/Basic/plus.svg" />
              </span>
              Thêm mới
            </b-button>
            <b-button
              v-if="isInsertPermission"
              class="btn btn-success ml-2"
              type="button"
              @click="importItems"
            >
              <span class="svg-icon">
                <inline-svg src="/media/svg/icons/Neolex/Basic/upload-cloud.svg" />
              </span>
              Import
            </b-button>
          </b-col>
        </b-row>      
    </Wrapper>

    <b-overlay :show="loading">
      <b-container fluid class="ProgramActivity-list-page__body mb-6 mt-6">
        <b-row>
          <b-col>
            <div class="card card-custom gutter-b">
              <div class="card-body mt-0">
                <template-table
                  :column="column"
                  :data="data"
                  :paging="paging"
                  :tableAction="false"
                  :selectAction="false"
                  :searchAction="false"
                  @search="searchRequest"
                  @reset="resetRequest"
                  @sortBy="sortRequest"
                >
                  <template v-slot:body="{ item }">
                    <td style="width: 20px">
                      <action-dropdown
                        :value="item"
                        :show_edit="isUpdatePermission"
                        :show_delete="false"
                        :show_copy="false"
                        :boundary="data.length > 2 ? 'scrollParent' : 'window'"
                        @view="viewItem"
                        @edit="editItem"
                        @copy="copyItem"
                      >
                        <b-dropdown-text
                          v-if="isDeletePermission"
                          tag="div"
                          class="navi-item cursor-pointer"
                        >
                          <a
                            class="navi-link cursor-pointer"
                            @click="deleteItem(item)"
                          >
                            <span
                              class="menu-icon svg-icon svg-icon-sm"
                              :class="
                                item.active ? 'text-danger' : 'text-primary'
                              "
                            >
                              <inline-svg
                                class="svg-icon"
                                src="/media/svg/icons/Neolex/Basic/power.svg"
                              />
                            </span>
                            <span
                              class="success navi-text"
                              :class="
                                item.active ? 'text-danger' : 'text-primary'
                              "
                            >
                              {{ item.active ? 'Inactive' : 'Active' }}
                            </span>
                          </a>
                        </b-dropdown-text>
                      </action-dropdown>
                    </td>
                    <td class="text-center">
                      {{ item.code }}
                    </td>
                    <td class="text-center">
                      {{ item.name }}
                    </td>
                    <td class="text-center">
                      {{ item.activityTypeId }}
                    </td>
                    <td class="text-center">
                      {{ item.programActivityLevelId }}
                    </td>
                    <td class="text-center">
                      {{ item.activityTopicId }}
                    </td>
                    <td class="text-center">
                      {{ item.activityDisplayDayId }}
                    </td>
                    <td class="text-center">
                      {{ item.subject }}
                    </td>
                    <td class="text-center">
                      {{ item.startDateTime }}
                    </td>
                    <td class="text-center">
                      {{ item.endDateTime }}
                    </td>
                    <td class="text-center">
                      {{ item.reminderNumbers }}
                    </td>
                    <td class="text-center">
                      {{ item.detailLink }}
                    </td>
                    <td class="text-center">
                      {{ item.redirectLink }}
                    </td>
                    <td class="text-center">
                      {{ item.videoLink }}
                    </td>
                  </template>
                </template-table>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </b-overlay>
  </div>
</template>

<script>
import { TAG_TYPE } from '../../../core/plugins/constants';
export default {
  data() {
    return {
      paging: {
        page: 1,
        pageSize: 10,
        total: 0,
      },
      filter: {code: null,name: null,activityTypeId: null,programActivityLevelId: null,activityTopicId: null,activityDisplayDayId: null,subject: null,startDateTime: null,endDateTime: null,reminderNumbers: null,detailLink: null,redirectLink: null,videoLink: null,
      },
      sort: {
        by: null,
        order: null,
      },      
      column: [
      {
          key: 'actionDropdown',
          label: '',
          sortable: false,
          style: {
            width: '5%',
          },
        },{
                key: 'code',
                label: 'Code',
                sortable: true,                
              },{
                key: 'name',
                label: 'Name',
                sortable: true,                
              },{
                key: 'activityTypeId',
                label: 'ActivityTypeId',
                sortable: true,                
              },{
                key: 'programActivityLevelId',
                label: 'ProgramActivityLevelId',
                sortable: true,                
              },{
                key: 'activityTopicId',
                label: 'ActivityTopicId',
                sortable: true,                
              },{
                key: 'activityDisplayDayId',
                label: 'ActivityDisplayDayId',
                sortable: true,                
              },{
                key: 'subject',
                label: 'Subject',
                sortable: true,                
              },{
                key: 'startDateTime',
                label: 'StartDateTime',
                sortable: true,                
              },{
                key: 'endDateTime',
                label: 'EndDateTime',
                sortable: true,                
              },{
                key: 'reminderNumbers',
                label: 'ReminderNumbers',
                sortable: true,                
              },{
                key: 'detailLink',
                label: 'DetailLink',
                sortable: true,                
              },{
                key: 'redirectLink',
                label: 'RedirectLink',
                sortable: true,                
              },{
                key: 'videoLink',
                label: 'VideoLink',
                sortable: true,                
              },
              ],
      data: [],
      loading: false,
    };
  },
  computed: {
    searchParams() {
      const payload = this.removeEmpty({        code: this.filter.code,        name: this.filter.name,        activityTypeId: this.filter.activityTypeId,        programActivityLevelId: this.filter.programActivityLevelId,        activityTopicId: this.filter.activityTopicId,        activityDisplayDayId: this.filter.activityDisplayDayId,        subject: this.filter.subject,        startDateTime: this.filter.startDateTime,        endDateTime: this.filter.endDateTime,        reminderNumbers: this.filter.reminderNumbers,        detailLink: this.filter.detailLink,        redirectLink: this.filter.redirectLink,        videoLink: this.filter.videoLink,
        sortBy: this.sort.by ? `${this.sort.by} ${this.sort.order}` : null,
        page: this.paging.page,
        size: this.paging.pageSize,
      });
      const params = new URLSearchParams();
      for (const property in payload) {
        params.append(property, payload[property]);
      }      
      return params;
    },
  },
  watch: {
    'paging.page'() {
      this.loadData();
    },
    'paging.pageSize'() {
      this.loadData();
    },
  },
  methods: {
    searchRequest() {
      this.loadData();
      document.body.click();
    },
    resetRequest() {
        this.filter.code = null;      this.filter.name = null;      this.filter.activityTypeId = null;      this.filter.programActivityLevelId = null;      this.filter.activityTopicId = null;      this.filter.activityDisplayDayId = null;      this.filter.subject = null;      this.filter.startDateTime = null;      this.filter.endDateTime = null;      this.filter.reminderNumbers = null;      this.filter.detailLink = null;      this.filter.redirectLink = null;      this.filter.videoLink = null;
      this.loadData();
      document.body.click();
    },
    sortRequest(sortData) {
      this.sort = {
        by: sortData.column,
        order: sortData.order,
      };
      this.loadData();
    },
    viewItem(item) {
      this.$router.push({
        name: 'ProgramActivity_detail',
        params: {
          id: item.id,
        },
      });
    },
    editItem(item) {
      this.$router.push({
        name: 'ProgramActivity_edit',
        params: {
          id: item.id,
        },
      });
    },
    createItem() {
      this.$router.push({
        name: 'ProgramActivity_create',
      });
    },
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        this.veeFields[ref].dirty &&
        this.veeFields[ref].validated
      ) {
        return this.veeFields[ref].valid;
      }
      return null;
    },
    importItems() {
      this.$router.push({
        name: 'ProgramActivity_import',
      });
    },
    deleteItem(item) {
      let text = item.active ? 'Inactive' : 'Active';
      let btn = item.active ? 'btn-inactive' : 'btn-active';
      this.$swal({
        title: '',
        text: `Bạn có chắc chắn muốn chuyển trạng thái ${item.id} thành ${text} không?`,
        icon: '/media/svg/icons/SweetAlert/alert-triangle-red.svg',
        buttons: {
          cancel: {
            text: 'Hủy',
            value: false,
            visible: true,
            className: 'btn btn-secondary',
            closeModal: true,
          },
          confirm: {
            text: 'Chắc chắn',
            value: true,
            visible: true,
            className: `btn ${btn}`,
            closeModal: true,
          },
        },
      }).then(
        function (result) {
          if (result) {
            // inactive all
            this.changeStatus(item);
          }
        }.bind(this),
      );
    },
    copyItem(item) {
      this.$router.push({
        name: 'ProgramActivity_detail',
        params: {
          form_type: 'copy',
          id: item.id,
        },
      });
    },
    async changeStatus(item) {
      this.$store.commit('context/setLoading', true);
      const params = {
        id: item.id,
        active: !item.active,
      };
      const { error } = await this.$store.dispatch('CHANGE_STATUS', params);

      if (error) {
        this.$store.commit('context/setLoading', false);
        return this.$toastr.e({
          title: 'Lỗi !',
          msg: error.message,
        });
      }
      this.$toastr.s({
        title: 'Thành công !',
        msg: 'Cập nhật thành công',
      });
      this.$store.commit('context/setLoading', false);
      this.loadData();
    },
    async loadData() {
      try {
        this.$store.commit('context/setLoading', true);
        const { data } = await this.$api.get('Admin/ProgramActivity/portal', {
          params: this.searchParams,
        });
        this.data =
          data.items.map((el) => {
            return {
              ...el,
              position:
                el.accountPositionMappings.length &&
                el.accountPositionMappings[0].position.name,
              hospital: this.getDataHospital(
                el.accountRule?.accountRuleTagMappings || [],
              ),
            };
          }) || [];
        this.paging.total = data.total;
      } catch (error) {
        this.$toastr.e({
          title: 'Lỗi',
          msg: error,
        });
      } finally {
        this.$store.commit('context/setLoading', false);
      }
    },
    getDataHospital(tags) {
      if (!tags || !tags.length) return null;
      const agencies = tags.filter((el) => el.tag.type === TAG_TYPE.AGENCY);
      return agencies.map((el) => el.tag.name).join(', ');
    },
    getStatus(status) {
      if (status) return 'active';
      return 'inactive';
    },
    searchDebounce(value) {
      this.filter.searchText = value;
      this.resetPaging();
    },
    resetPaging() {
      this.paging.page = 1;
      this.loadData();
    },
    getSearchDataPrepare() {
      this.$api
        .get('Admin/ProgramActivity/portal/PrepareSearchFormItem')
        .then(({ data }) => {
          const { agencyList, genderList, positionList, statusList } = data;
          this.agencies = agencyList;
          this.positions = positionList;
          this.statuses = statusList;
          this.genders = genderList;
        })
        .catch((error) => {
          this.$toastr.e({
            title: 'Lỗi',
            msg: error,
          });
        });
    },
  },
  async created() {
    await Promise.all([this.loadData(), this.getSearchDataPrepare()]);
  },
};
</script>
<style lang="scss" scoped>
.status {
  padding: 6px 24px;
  border-radius: 20px;
  color: #fff;
  text-transform: capitalize;
  width: 96px;
  text-align: center;

  &.active {
    background: #21a567;
  }

  &.inactive {
    background: #ff5756;
  }
}

.text-overflow {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.cell-overflow {
  max-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.dropdown-form-filter {
  .dropdown-menu {
    .container {
      width: 850px;
    }
  }
}

.search-input {
  min-width: 220px;
}
</style>
